import React from 'react';
import { Link } from 'react-router-dom';

import './_ResetPassword.scss';

import { Button, DataCard, Input, Alert } from '../../components';

import { ResetPasswordProvider } from '../providers';

const ResetPassword = () => (
  <ResetPasswordProvider>
    {({ onSubmit, loading, errorMessage, successMessage, form }) => (
      <section className="container sign-in">
        <DataCard title="Choose a new Password">
          <form onSubmit={onSubmit}>
            {errorMessage && <Alert classes="error">{errorMessage}</Alert>}
            {successMessage && (
              <Alert classes="success">{successMessage}</Alert>
            )}
            <Input
              type="password"
              placeholder="Password"
              name="password"
              readOnly={false}
              classes={`border-bottom ${
                form.password.input.errorMessage ? 'error' : ''
              }`}
              {...form.password.input}
            />
            <Input
              type="password"
              placeholder="Confirm Password"
              name="confirm-password"
              readOnly={false}
              classes={`border-bottom ${
                form.confirmPassword.input.errorMessage ? 'error' : ''
              }`}
              {...form.confirmPassword.input}
            />
            <Button
              type="submit"
              classes={`center ${loading ? 'loading' : ''}`}
            >
              Reset Password
            </Button>
            <div className="create-account">
              Don't have an account? <Link to="/sign-up">Sign Up</Link>
            </div>
          </form>
        </DataCard>
      </section>
    )}
  </ResetPasswordProvider>
);

export default ResetPassword;
